import { createEntityAdapter } from '@reduxjs/toolkit';
import { Cattle } from 'data/cattle';

const cattleAdapter = createEntityAdapter<Cattle>({
  selectId: (cattle) => cattle.id,
});

export default cattleAdapter;
